import React, {useState} from 'react';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import {API_URL} from '../../constants';
import {AXIOS_NOT_FOUND_REDIRECT_OPT_OUT} from '../../axiosNotFoundRedirect';

const errorMessage = (error) => {
    if (error?.response?.data?.errors) {
        return Object.values(error.response.data.errors)
            .flat()
            .join(' ');
    }

    return error?.response?.data?.message || 'An error occurred. Please try again later.';
};

const PickupDeleteAction = ({
    canDelete,
    pickupId,
    token,
    onDeleted,
    onError,
    onUnauthorized,
    onConflict,
}) => {
    const [isSubmitted, setIsSubmitted] = useState(false);

    if (!canDelete) return null;

    const deletePickup = async () => {
        if (!window.confirm(
            `Permanently delete delivery #${pickupId}? This action cannot be undone.`
        )) return;

        setIsSubmitted(true);
        onError('');

        try {
            await axios.delete(`${API_URL}/api/admin/pickups/${pickupId}`, {
                ...AXIOS_NOT_FOUND_REDIRECT_OPT_OUT,
                headers: {'Authorization': `Bearer ${token}`},
            });
            onDeleted();
        } catch (error) {
            if (error?.response?.status === 401) {
                onUnauthorized();
                return;
            }

            if (error?.response?.status === 404) {
                onDeleted();
                return;
            }

            onError(errorMessage(error));

            if ([409, 422].includes(error?.response?.status)) {
                onConflict?.();
            }
        } finally {
            setIsSubmitted(false);
        }
    };

    return (
        <button
            className="btn btn-danger mb-2 ml-1"
            type="button"
            onClick={deletePickup}
            disabled={isSubmitted}
        >
            {isSubmitted
                ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />&nbsp;Deleting...</>
                : 'Delete Delivery'
            }
        </button>
    );
};

export default PickupDeleteAction;
